import React from 'react';
import { Row, Col, Card, Skeleton } from 'antd';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import moment from 'moment';
import Link from '../../Link';
import styles from './styles.less';
import { articleClicked } from '../../../utils/events/articles';

const Blog = ({ articles }) => {
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    if (articles.length && Object.keys(articles[0]).length) {
      setLoading(false);
    }
  }, [articles]);

  return (
    <Row className={styles.row} gutter={20} type="flex">
      {articles.map((blog, index) => {
        const date = moment(blog.date);
        const year = date.format('YYYY');
        const month = date.format('MM');
        const day = date.format('DD');

        return (
          <Col className={styles.col} xs={24} md={24 / articles.length} key={blog.id || index}>
            <div onClick={() => articleClicked(blog)}>
              <Link
                route="article"
                year={year}
                month={month}
                day={day}
                url={blog.shortId}
                title={blog.title}
              >
                <Card
                  cover={
                    <div className={styles.container}>
                      <LazyLoad>
                        <img src={blog.image} alt={blog.title} />
                      </LazyLoad>
                      <Skeleton loading={loading} active style={{ paddingTop: 200 }}>
                        <div className={styles.title}>
                          <span dangerouslySetInnerHTML={{ __html: blog.title }} />
                        </div>
                      </Skeleton>
                    </div>
                  }
                />
              </Link>
            </div>
          </Col>
        );
      })}
    </Row>
  );
};

Blog.propTypes = {
  articles: PropTypes.array.isRequired,
};

export default Blog;
